"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const RequirementRequest_1 = require("components/partial/RequirementRequest");
const Clients_1 = require("components/partial/Clients");
const RoadmapTypeContactEntity_1 = require("types/api/entity/RoadmapTypeContactEntity");
const native_1 = require("@react-navigation/native");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const ModalRequirementSuccess_1 = __importDefault(require("components/modal/ModalRequirementSuccess"));
const requirement_1 = require("services/requirement");
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const modal_1 = require("components/modal");
const RequirementRequestAdd = ({ route, navigation }) => {
    const { client: clientParam, clear: clearParam, id: idParam, } = route?.params ?? {};
    //console.log("clearParam", clearParam);
    const toast = (0, native_base_1.useToast)();
    const existentClientChanged = React.useRef(false);
    const [requirement, setRequirement] = React.useState();
    const [initResponse, setInitResponse] = React.useState();
    const [client, setClient] = React.useState(clientParam);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (clientParam) {
            existentClientChanged.current = true;
            setClient(clientParam);
        }
    }, [clientParam?.id]));
    const [clear, setClear] = React.useState(clearParam);
    //console.log("clear", clear);
    const [address, setAddress] = React.useState();
    const [brand, setBrand] = React.useState();
    const [type, setType] = React.useState();
    const [objective, setObjective] = React.useState();
    const [phone, setPhone] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [panel, setPanel] = React.useState("");
    const [obs, setObs] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [imgModal, setImgModal] = React.useState();
    const [showImgModal, setShowImgModal] = React.useState(false);
    const [showModalSuccess, setShowModalSuccess] = React.useState(false);
    const [successAddMsg, setSuccessAddMessage] = React.useState("Tu requerimiento se registró correctamente");
    const onSocioPressed = () => {
        if ((idParam ?? "") != "")
            return;
        navigation.navigate(Clients_1.name, {
            origin: "RequirementRequestAdd",
        });
    };
    const onSendPressed = () => {
        const onSuccess = (response) => {
            setSuccessAddMessage(response.msg ?? "Tu requerimiento se registró correctamente");
            setShowModalSuccess(true);
            setAddress(undefined);
            setBrand(undefined);
            setType(undefined);
            setObjective(undefined);
            setPhone("");
            setEmail("");
            setPanel("");
            setObs("");
            setFiles([]);
        };
        const onError = (msg) => {
            toast.show({ description: msg });
        };
        (0, requirement_1.doRequirementSave)({
            params: {
                data: {
                    cardCode: client?.id,
                    direccion: address?.direccion, //"Av. los alamos 5588";
                    direccionId: address?.id, //"Av. los alamos 5588";
                    marca: brand?.code, //"1";
                    tipo: type?.code, //"2";
                    objetivo: objective?.code, //"3";
                    telefono: phone, //"5874478899";
                    correo: email, //"jhon@doe.com";
                    textoPanel: panel, //"texto panel";
                    observaciones: obs, //"observaciones";
                    numFiles: files.length, //2;
                },
                files: files,
            },
            callback: {
                onSuccess: onSuccess,
                onFail: onError,
                onLoading: setIsLoading,
            },
        });
    };
    const onBackPress = () => {
        navigation.jumpTo(RequirementRequest_1.name);
    };
    //file
    const [files, setFiles] = React.useState([]);
    const onDrop = React.useCallback((acceptedFiles) => {
        if (files.length + acceptedFiles.length <= (initResponse?.data?.maxAdjuntos ?? 1)) {
            setFiles(files => [...files, ...acceptedFiles]);
        }
        else {
            toast.show({ description: `Máximo ${initResponse?.data?.maxAdjuntos ?? 1} adjuntos` });
        }
    }, [initResponse?.data?.maxAdjuntos, files.length]);
    //
    const dropzoneRef = React.createRef();
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        const onSuccess = (iResponse) => {
            setInitResponse(iResponse);
            if ((idParam ?? "") != "") {
                const onSuccessGet = (response) => {
                    setClient({ nombre: response.data?.cardName });
                    setRequirement(response.data);
                    setAddress({ direccion: response.data?.direcion ?? "" });
                    setBrand(iResponse?.data?.marcas?.find(e => e.code == response.data?.marcaCode));
                    setType(iResponse?.data?.tipos?.find(e => e.code == response.data?.tipoCode));
                    setObjective(iResponse?.data?.objetivos?.find(e => e.code == response.data?.objCode));
                    setPhone(response.data?.telefono ?? "");
                    setEmail(response.data?.correo ?? "");
                    setPanel(response.data?.texto ?? "");
                    setObs(response.data?.observacion ?? "");
                };
                (0, requirement_1.doRequirementGet)({
                    params: {
                        data: {
                            id: idParam,
                        },
                    },
                    callback: {
                        onSuccess: onSuccessGet,
                    },
                });
            }
        };
        (0, requirement_1.doRequirementInit)({
            params: {},
            callback: {
                onSuccess,
            },
        });
        return () => {
            console.log("useFocusEffect return");
        };
    }, [clearParam]));
    React.useEffect(() => {
        console.log("clearParam", clearParam);
        if (clearParam == true) {
            //setClient(undefined);
            setAddress(undefined);
            setBrand(undefined);
            setType(undefined);
            setObjective(undefined);
            setPhone("");
            setEmail("");
            setPanel("");
            setObs("");
        }
        return () => {
            console.log("React.useEffect return");
        };
    }, [clearParam]);
    React.useEffect(() => {
        setPhone(clientParam?.tel ?? "");
        setEmail(clientParam?.email ?? "");
    }, [clientParam?.id]);
    return (<>
			<native_base_1.ScrollView style={{ width: "100%" }} _contentContainerStyle={{
            alignItems: "center",
            px: {
                base: 15,
                md: 15,
            },
        }}>
				<native_base_1.View w={{ base: "100%", md: "90%", lg: "75%", xl: "65%" }} pb="10">
					<native_base_1.VStack mt="30">
						<native_base_1.HStack>
							<native_base_1.Pressable onPress={onBackPress}>
								<native_base_1.Image source={require("images/ic_back.svg")} alt={theme_1.Str.alt.ic_back} w="20" h="20"/>
							</native_base_1.Pressable>
							<native_base_1.Heading variant="h1" ml="10"></native_base_1.Heading>
						</native_base_1.HStack>
						<native_base_1.Pressable mt={15} onPress={onSocioPressed} alignSelf="start">
							<native_base_1.HStack alignItems="center" backgroundColor="white" borderRadius={10} shadow={1} px={15} py={5}>
								<native_base_1.Text>{client?.nombre ?? "Socio de negocios"}</native_base_1.Text>
								<native_base_1.Image alt="_" source={icons_1.default.icSearch} w={15} h={15} ml={20}/>
							</native_base_1.HStack>
						</native_base_1.Pressable>
						<SelecAddressModal address={address} onSelectedAddress={setAddress} disabled={(idParam ?? "") != ""}/>

						{(idParam ?? "") != "" ? (<>
								<native_base_1.Text px={15} py={8} bg="white" borderRadius={8} shadow={1}>
									{brand?.name ?? ""}
								</native_base_1.Text>
							</>) : (<>
								<native_base_1.Menu w="190" trigger={triggerProps => {
                console.log(triggerProps);
                return (<native_base_1.Pressable bg="white" borderRadius={5} shadow={2} accessibilityLabel="More options menu" {...triggerProps}>
												<native_base_1.HStack alignItems="center" px="7" py="5">
													<native_base_1.Text flex={1}>{brand?.name ?? "Marca"}</native_base_1.Text>
													<native_base_1.View w={10}/>
													<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
												</native_base_1.HStack>
											</native_base_1.Pressable>);
            }}>
									{initResponse?.data?.marcas?.map(e => {
                return (<native_base_1.Menu.Item onPress={() => {
                        if ((idParam ?? "") != "")
                            return;
                        setBrand(e);
                    }}>
												{e.name ?? ""}
											</native_base_1.Menu.Item>);
            })}
								</native_base_1.Menu>
							</>)}

						<native_base_1.HStack mt={20}>
							<native_base_1.View flex={1} mr={20}>
								{(idParam ?? "") != "" ? (<native_base_1.Text px={15} py={8} bg="white" borderRadius={8} shadow={1}>
										{type?.name ?? ""}
									</native_base_1.Text>) : (<native_base_1.Menu flex={1} w="190" trigger={triggerProps => {
                console.log(triggerProps);
                return (<native_base_1.Pressable bg="white" borderRadius={5} shadow={2} accessibilityLabel="More options menu" {...triggerProps}>
													<native_base_1.HStack alignItems="center" px="7" py="5">
														<native_base_1.Text flex={1}>{type?.name ?? "Tipo"}</native_base_1.Text>
														<native_base_1.View w={10}/>
														<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
													</native_base_1.HStack>
												</native_base_1.Pressable>);
            }}>
										{initResponse?.data?.tipos?.map(e => {
                return (<native_base_1.Menu.Item onPress={() => {
                        if ((idParam ?? "") != "")
                            return;
                        setType(e);
                    }}>
													{e.name ?? ""}
												</native_base_1.Menu.Item>);
            })}
									</native_base_1.Menu>)}
							</native_base_1.View>

							<native_base_1.View flex={1}>
								{(idParam ?? "") != "" ? (<native_base_1.Text px={15} py={8} bg="white" borderRadius={8} shadow={1}>
										{objective?.name ?? ""}
									</native_base_1.Text>) : (<native_base_1.Menu flex={1} w="190" trigger={triggerProps => {
                console.log(triggerProps);
                return (<native_base_1.Pressable bg="white" borderRadius={5} shadow={2} accessibilityLabel="More options menu" {...triggerProps}>
													<native_base_1.HStack alignItems="center" px="7" py="5">
														<native_base_1.Text flex={1}>{objective?.name ?? "Objetivo"}</native_base_1.Text>
														<native_base_1.View w={10}/>
														<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
													</native_base_1.HStack>
												</native_base_1.Pressable>);
            }}>
										{initResponse?.data?.objetivos?.map(e => {
                return (<native_base_1.Menu.Item onPress={() => {
                        if ((idParam ?? "") != "")
                            return;
                        setObjective(e);
                    }}>
													{e.name ?? ""}
												</native_base_1.Menu.Item>);
            })}
									</native_base_1.Menu>)}
							</native_base_1.View>
						</native_base_1.HStack>
						<native_base_1.Text mt={20}>Detalle de requerimiento:</native_base_1.Text>
						<native_base_1.View mt="10" width="100%" height={1} color={theme_1.Colors.colorDarkGray1}/>
						<native_base_1.HStack mt={20}>
							<native_base_1.VStack flex={1} background="white" borderRadius={theme_1.Sizes.inputRadius} px={theme_1.Sizes.inputPaddingHorizontal} py={theme_1.Sizes.inputPaddingVertical} borderWidth={1} borderColor={theme_1.Colors.colorDarkGray1}>
								<native_base_1.Text>Telef:</native_base_1.Text>
								<native_base_1.Input borderWidth={0} value={phone} onChangeText={setPhone} isDisabled={(idParam ?? "") != ""}/>
							</native_base_1.VStack>
							<native_base_1.VStack flex={1} ml={15} background="white" borderRadius={theme_1.Sizes.inputRadius} px={theme_1.Sizes.inputPaddingHorizontal} py={theme_1.Sizes.inputPaddingVertical} borderWidth={1} borderColor={theme_1.Colors.colorDarkGray1}>
								<native_base_1.Text>E-mail:</native_base_1.Text>
								<native_base_1.Input borderWidth={0} value={email} onChangeText={setEmail} isDisabled={(idParam ?? "") != ""}/>
							</native_base_1.VStack>
						</native_base_1.HStack>
						<native_base_1.VStack mt={20} background="white" borderRadius={theme_1.Sizes.inputRadius} px={theme_1.Sizes.inputPaddingHorizontal} py={theme_1.Sizes.inputPaddingVertical} borderWidth={1} borderColor={theme_1.Colors.colorDarkGray1}>
							<native_base_1.Text>Texto en requerimiento:</native_base_1.Text>
							<native_base_1.Input borderWidth={0} value={panel} onChangeText={setPanel} isDisabled={(idParam ?? "") != ""}/>
						</native_base_1.VStack>
						<native_base_1.Text mt={20}>Observaciones:</native_base_1.Text>
						<native_base_1.TextArea minH={100} value={obs} onChangeText={setObs} isDisabled={(idParam ?? "") != ""}/>

						{(idParam ?? "") == "" && (<>
								<native_base_1.Pressable onPress={() => dropzoneRef.current?.open()} mt={20}>
									<native_base_1.HStack py={5} alignItems="center">
										<native_base_1.Image source={icons_1.default.icPlus} w={10} h={10}/>
										<native_base_1.Text ml={10}>Adjuntar imágenes</native_base_1.Text>
									</native_base_1.HStack>
								</native_base_1.Pressable>
								<react_dropzone_1.default ref={dropzoneRef} onDrop={onDrop} onError={err => {
                console.log(err);
            }} maxFiles={initResponse?.data?.maxAdjuntos ?? 1} multiple={true} accept={{
                "image/png": [".png", ".jpg", ".jpeg"],
                //"application/pdf": [".pdf"],
            }}>
									{({ getRootProps, getInputProps, isDragActive }) => (<div {...getRootProps()} style={{ width: "100%" }}>
											<input {...getInputProps()}/>
											{isDragActive ? (<p style={{
                        marginLeft: 20,
                        flex: 1,
                        width: "100%",
                    }}>
													Arrastra los archivos aqui ...
												</p>) : (<p style={{
                        marginLeft: 20,
                        flex: 1,
                        width: "100%",
                    }}>
													Arrastra y suelta los archivos aqui, o click para seleccionar
													archivos.
												</p>)}
										</div>)}
								</react_dropzone_1.default>
							</>)}

						<native_base_1.HStack mt={10}>
							<native_base_1.VStack>
								{files.map(e => (<native_base_1.HStack>
										<native_base_1.Text mr={10}>{e.name ?? ""},</native_base_1.Text>
										<native_base_1.Pressable onPress={() => {
                setFiles(old => {
                    const filtered = old.filter(filter => filter.name != e.name);
                    return filtered;
                });
            }} p={10}>
											<native_base_1.Image source={icons_1.default.icClose} w={10} h={10}/>
										</native_base_1.Pressable>
									</native_base_1.HStack>))}
							</native_base_1.VStack>
						</native_base_1.HStack>
						{(requirement?.adjuntos?.length ?? 0) > 0 && (<>
								<native_base_1.Text mt={10}>{"Imágenes adjuntas"}</native_base_1.Text>
								<native_base_1.HStack mt={10}>
									{requirement?.adjuntos?.map(e => (<native_base_1.Pressable mr={5} onPress={() => {
                    setImgModal(e);
                    setShowImgModal(true);
                }}>
											<native_base_1.Image source={{ uri: e ?? "", width: 70, height: 70 }} w={70} h={70}/>
										</native_base_1.Pressable>))}
								</native_base_1.HStack>
							</>)}

						{(idParam ?? "") != "" && (requirement?.urlAdjProp?.length ?? 0) > 0 && (<>
								<native_base_1.Text mt={10}>{requirement?.tituloProp ?? ""}</native_base_1.Text>
								<native_base_1.HStack mt={10}>
									{requirement?.urlAdjProp?.map(e => (<native_base_1.Pressable onPress={() => {
                    setImgModal(e);
                    setShowImgModal(true);
                }}>
											<native_base_1.Image source={{ uri: e ?? "", width: 70, height: 70 }} w={70} h={70}/>
										</native_base_1.Pressable>))}
								</native_base_1.HStack>
							</>)}
						{(idParam ?? "") != "" && (requirement?.comentario ?? "") != "" && (<>
								<native_base_1.Text mt={10}>{requirement?.tituloMotivoRechazo ?? ""}</native_base_1.Text>
								<native_base_1.TextArea mt={10} value={requirement?.comentario ?? ""} isDisabled={true}/>
							</>)}
						<native_base_1.Button onPress={onSendPressed} alignSelf="start" my={30} isDisabled={(idParam ?? "") != ""}>
							Enviar
						</native_base_1.Button>
					</native_base_1.VStack>
				</native_base_1.View>
			</native_base_1.ScrollView>
			<FullScreenLoad_1.default isVisible={isLoading}/>
			<ModalRequirementSuccess_1.default message={successAddMsg} isOpen={showModalSuccess} onClose={() => {
            navigation.navigate("RequirementRequestName");
            setShowModalSuccess(false);
        }}/>
			<modal_1.ModalImage isOpen={showImgModal} source={{ uri: imgModal }} onClose={() => {
            setShowImgModal(false);
        }}/>
		</>);
};
const TypeContactItem = ({ item, selectedItem, onPressed }) => {
    return (<native_base_1.Pressable onPress={onPressed}>
			<native_base_1.HStack alignItems="center" borderBottomWidth={1} borderBottomColor={theme_1.Colors.colorGray1} py={10}>
				<native_base_1.Image alt="_" source={item.code == RoadmapTypeContactEntity_1.RoadmapTypeContact.call ? icons_1.default.icPhone : icons_1.default.icHome} w={15} h={15} mr={15}/>
				<native_base_1.Text flex={1}>{item.name ?? ""}</native_base_1.Text>
				{selectedItem?.code == item.code && <native_base_1.Image alt="_" source={icons_1.default.icCheck} w={10} h={10} ml={10}/>}
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const SelecAddressModal = ({ address, disabled, onSelectedAddress }) => {
    const [showModal, setShowModal] = React.useState(false);
    return (<>
			<native_base_1.Pressable onPress={() => {
            if (disabled)
                return;
            setShowModal(true);
        }}>
				<native_base_1.Text mt={20} mb={20} borderRadius={theme_1.Sizes.inputRadius} minH={theme_1.Sizes.inputMinHeight} px={theme_1.Sizes.inputPaddingHorizontal} py={theme_1.Sizes.inputPaddingVertical} borderWidth={theme_1.Sizes.inputBorderWidth} borderColor={theme_1.Colors.colorDarkGray1}>
					{address?.direccion ?? "Ingresa dirección"}
				</native_base_1.Text>
			</native_base_1.Pressable>

			<modal_1.ModalSelectAddress quoteClientId={null} onListAddressSuccess={(addresses) => {
            if (addresses.length == 1) {
                onSelectedAddress(addresses?.[0]);
            }
        }} onSelectedAddress={(address) => {
            setShowModal(false);
            onSelectedAddress(address);
        }} isOpen={showModal} onClose={() => setShowModal(false)}/>
		</>);
};
exports.name = "RequirementRequestAddName";
exports.default = RequirementRequestAdd;
